import { IRequestOptions, TResponseResult } from 'models/api.model'
import {
  ICustomerInfoRaw,
  IGetUserSubscriptionsInfoRaw,
} from 'models/commonApi.model'

import { ApiService } from 'services/api.service'

import { RequestMethod } from 'root-constants'

export class CommonApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getUserSubscriptionsInfo(
    token: string,
    appName: string,
  ): Promise<TResponseResult<IGetUserSubscriptionsInfoRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: {
        token,
        app_name: appName,
      },
    }

    return this.api.makeRequest<IGetUserSubscriptionsInfoRaw>(
      `v1/subscriptions`,
      options,
    )
  }

  getCustomerInfo(
    token: string,
    appName: string,
  ): Promise<TResponseResult<ICustomerInfoRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: {
        token,
        app_name: appName,
      },
    }

    return this.api.makeRequest<ICustomerInfoRaw>(`v1/customers`, options)
  }

  getUserSubscriptionsInfoByEmail(
    email: string,
    appName: string,
  ): Promise<TResponseResult<IGetUserSubscriptionsInfoRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: {
        app_name: appName,
        email,
      },
    }

    return this.api.makeRequest<IGetUserSubscriptionsInfoRaw>(
      `v1/subscriptions`,
      options,
    )
  }

  getCustomerInfoByEmail(
    email: string,
    appName: string,
  ): Promise<TResponseResult<ICustomerInfoRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: {
        app_name: appName,
        email,
      },
    }

    return this.api.makeRequest<ICustomerInfoRaw>(`v1/customers`, options)
  }
}
